import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_CABIN: IWhereUsedSectionTab[] = [
    {
        title: 'Конференции',
        image: '/assets/images/usage/sinhroperevod/jpg-png/performance.jpg',
        image_webp: '/assets/images/usage/sinhroperevod/webp/performance.webp',
        text: `
            <p>При участии в&nbsp;мероприятии иностранных гостей или спикеров необходимо обеспечить синхронный перевод от&nbsp;выступающих к&nbsp;слушателям. Для этого необходимо устанавливать в&nbsp;зале отдельные кабины переводчиков для каждой пары переводчиков.</p>
            `,
    },
    {
        title: 'Переговоры',
        image: '/assets/images/usage/conference-system/jpg-png/speech.png',
        image_webp: '/assets/images/usage/conference-system/webp/speech.webp',
        text: `
            <p>При важных переговорах на&nbsp;нескольких языках необходимо исключить долгие паузы на&nbsp;перевод друг другу. Для этого используются персональные наушники с&nbsp;приемниками, куда направляется голос переводчиков, сидящих отдельно в&nbsp;звукоизолированной кабине. Такая система обеспечит максимальный комфорт и&nbsp;полное взаимопонимание между участниками дискуссии.</p>
            `,
    },
    {
        title: 'Лекции',
        image: '/assets/images/usage/sinhroperevod/jpg-png/performance-2.jpg',
        image_webp:
            '/assets/images/usage/sinhroperevod/webp/performance-2.webp',
        text: `
            <p>Если лекцию ведет иностранный докладчик, либо в&nbsp;зале присутствуют представители разных языков, необходимо использовать систему для синхронного перевода и&nbsp;кабину SPBAUDIO. Для этого всем участникам выдаются персональные приемники с&nbsp;наушниками, куда транслируется беспроводным способом голос переводчиков из&nbsp;специально оборудованной кабины, которая может находиться даже в&nbsp;другом помещении. В&nbsp;данном случае можно использовать также и&nbsp;настольную кабину. А&nbsp;если лекция не&nbsp;более часа, то&nbsp;справиться может и&nbsp;один переводчик, а&nbsp;значит, использовать достаточно одноместную кабину EC-11 или EC-31.</p>
            `,
    },
    {
        title: 'Театры',
        image: '/assets/images/usage/sinhroperevod/jpg-png/theater.png',
        image_webp: '/assets/images/usage/sinhroperevod/webp/theater.webp',
        text: `
            <p>Спектакли на&nbsp;иностранном языке набирают популярность, в&nbsp;том числе и&nbsp;из-за технического прогресса&nbsp;&mdash; ведь теперь, при использовании системы для синхронного перевода, стирается языковой барьер между зрителем и&nbsp;артистами.</p>
            <p>Удобней всего приготовить заранее текст перевода на&nbsp;нужном языке и&nbsp;просто надиктовывать его в&nbsp;гарнитуру переводчика, сидя в&nbsp;отдельной кабине (настольная или напольная). При этом количество языков может быть несколько&nbsp;&mdash; для этого требуется только поставить дополнительные пульты SPBAUDIO MAX и&nbsp;кабины SPBAUDIO EUROCAB.</p>
            `,
    },
    {
        title: 'Университеты',
        image: '/assets/images/usage/sinhroperevod/jpg-png/rzd-lecture.jpg',
        image_webp: '/assets/images/usage/sinhroperevod/webp/rzd-lecture.webp',
        text: `
            <p>Использование в&nbsp;системе обучения опыта иностранных специалистов, студентов или спикеров становится нормой в&nbsp;эпоху глобализации. Система синхронного перевода и&nbsp;кабина SPBAUDIO позволяет осуществить беспроводную передачу сигнала переводчиков в&nbsp;наушники всем учащимся, вне зависимости от&nbsp;размера аудитории. Если размер помещения не&nbsp;позволяет разместить большую напольную кабину, то&nbsp;можно использовать настольный компактный вариант SPBAUDIO EUROCAB-3 или даже одноместную кабину SPBAUDIO EUROCAB-31.</p>
            `,
    },
    {
        title: 'Онлайн мероприятия',
        image: '/assets/images/usage/sinhroperevod/jpg-png/sinhroperevod-in-translation-booth-3.jpg',
        image_webp:
            '/assets/images/usage/sinhroperevod/webp/sinhroperevod-in-translation-booth-3.webp',
        text: `
            <p>При проведении многоязыковых мероприятий с&nbsp;использованием онлайн-платформ, переводчику необязательно находиться в&nbsp;помещении. Но&nbsp;необходимо обеспечить распространение беспроводного сигнала в&nbsp;наушники оффлайн слушателей в&nbsp;зале. Для этого ноутбук коммутируется с&nbsp;передатчиками нашей системы синхронного перевода, а&nbsp;посетителям раздаются приемники с&nbsp;наушниками. Также возможно объединение работы переводчиков как в&nbsp;зале в&nbsp;изолированной кабине SPBAUDIO EUROCAB, так и&nbsp;онлайн.</p>
            `,
    },
    {
        title: 'Тифлокомментирование',
        image: '/assets/images/usage/cabin/jpg-png/theater.png',
        image_webp: '/assets/images/usage/cabin/webp/theater.webp',
        text: `
            <p>При работе тифлокомментатора необходимо обеспечить максимальную звукоизоляцию с&nbsp;помощью напольной кабины SPBAUDIO EUROCAB-1. Тогда в&nbsp;наушниках слушателей голос комментатора будет слышен без лишних призвуков и&nbsp;шума.</p>
            `,
    },
]

export default WHERE_USED_CABIN
